// @ts-nocheck

import { createSelector } from 'reselect';

import { Target } from '../../client';
import {
  selectBasketIsCashout,
  selectBasketIsLoading,
  selectBasketMode,
} from '../../selectors/basket/basketPrimary.selector';
import { selectBasketShowResume, selectBasketIsSummaryKeyboardVisible } from '../../selectors/basketCommon.selector';
import { getNbItems } from '../../selectors/basketItems.selector';

const selectBasketFooterProps = createSelector(
  [
    selectBasketMode,
    selectBasketIsLoading,
    selectBasketIsCashout,
    selectBasketIsSummaryKeyboardVisible,
    getNbItems,
    selectBasketShowResume,
  ],
  (mode, isLoading, isCashout, isKeyboardVisible, nbItems, showResume) => {
    const isEmpty = nbItems === 0;
    return {
      isEmpty,
      isLoading,
      isCashout,
      showResume,
      isMobile: Target.__MOBILE__,
      mode,
      isKeyboardVisible,
    };
  },
);

export default selectBasketFooterProps;
